import { option } from 'fp-ts';

/**
 * @abstract Option<T[]> -> Option<T[]>
 */
export function compactFromArray<T extends Array<unknown>>(maybeSourceArray: option.Option<T>) {
  return option.chain<T, T>((sourceArray) => {
    if (sourceArray.length <= 0) {
      return option.none;
    }
    return option.some(sourceArray);
  })(maybeSourceArray);
}
